'use client'

import { twMerge } from '@/lib/classname/twMerge'
import { TextSkeleton } from '@/ui/skeleton/TextSkeleton'
import { ProductBuyBoxPricesSkeleton } from './ProductBuyBoxPricesSkeleton'

export function ProductBuyBoxSkeleton() {
  return (
    <div
      className={twMerge('relative mb-3 flex w-full flex-col gap-2 rounded-sm p-3 shadow-xl')}
      data-testid="product-buy-box-skeleton"
    >
      <ProductBuyBoxPricesSkeleton />

      <div className="desktop:bg-transparent fixed bottom-0 left-0 z-header flex w-full justify-center bg-white p-2 shadow-xl desktop:relative desktop:z-base desktop:w-auto desktop:justify-normal desktop:p-0 desktop:shadow-none">
        <TextSkeleton className="w-[14rem]" size="md" leading="normal" />
      </div>
    </div>
  )
}
